/*****************************************************************************/
/*  File Name: treatmentTable.js                                             */
/*  Date:      July 10, 2023                                                 */
/*  Author:    Christopher Cressman                                          */
/*  Purpose:   This is the table that will show how much faster you will 
/*             pay it off if you have multiple tips 
/*
/*****************************************************************************/

import React from 'react';
import { withTranslation } from 'react-i18next';

//import styles from './styles/roi.module.scss';
//import * as TIMERANGE from '../../constants/timeRanges';
import { useROIContext } from '../../context/roiContext';
import styles from './styles/roi.module.scss';

import { BarChart, Bar, XAxis, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import { convertToCurrencyChart } from '../../functions/convertCurrency';
import TierColor from './functions/getTierColor';
import { roundNumberUpToWhole } from '../../functions/roundNumberUp';
import * as MODES from '../../constants/modes';

function ChartBlock({ t }) {
  //Load all of the default component varaibles

  const { chartData, chartXData, currentTierBreakEven, newxtTierBreakEven, roiMode, consumerDifference } = useROIContext();

  //console.log('this is my selected Breakwodn - ---', selectedTimeBreakdown);
  //console.log('this is my consumer difference ----->', consumerDifference);

  return (
    <div className={styles.chartBlock}>
      {chartData.length > 0 ? (
        <ResponsiveContainer width='100%' height='100%'>
          <BarChart
            width={500}
            height={250}
            data={chartData}
            margin={{
              top: 20,
              right: 30,
              bottom: 5,
            }}
          >
            <XAxis dataKey='name' />
            <Tooltip formatter={convertToCurrencyChart} />
            <Legend />
            {chartXData.map((xAxis) => (
              <Bar dataKey={xAxis.key} fill={`${TierColor(xAxis.key)}`} key={xAxis.key} />
            ))}
          </BarChart>
        </ResponsiveContainer>
      ) : (
        ''
      )}

      {roiMode === MODES.capital ? (
        currentTierBreakEven.breakEven ? (
          <div className={styles.tierBreakEven}>
            <div className={styles.breakEven} style={{ color: TierColor(currentTierBreakEven.tier) }}>
              {roundNumberUpToWhole(currentTierBreakEven.breakEven)}
            </div>
            <div className={styles.copy}>
              #{currentTierBreakEven.breakdown} to
              <br /> break even at
              <br /> <span style={{ color: TierColor(currentTierBreakEven.tier) }}> {currentTierBreakEven.tier}</span>
            </div>
          </div>
        ) : (
          ''
        )
      ) : (
        <div className={styles.tierBreakEven}>
          <div className={styles.breakEven} style={{ color: TierColor(currentTierBreakEven.tier) }}>
            {convertToCurrencyChart(consumerDifference.growthDifference)}
          </div>
          <div className={styles.copy}>
            Potential {consumerDifference.breakdown}
            <br /> Profit difference
          </div>
        </div>
      )}

      {roiMode === MODES.capital ? (
        newxtTierBreakEven.breakEven ? (
          <div className={styles.nextTierBreakEven}>
            <div className={styles.breakEven} style={{ color: TierColor(newxtTierBreakEven.tier) }}>
              {roundNumberUpToWhole(newxtTierBreakEven.breakEven)}
            </div>
            <div className={styles.copy}>
              #{newxtTierBreakEven.breakdown} to
              <br /> break even at
              <br /> <span style={{ color: TierColor(newxtTierBreakEven.tier) }}> {newxtTierBreakEven.tier}</span>
            </div>
          </div>
        ) : (
          ''
        )
      ) : (
        ''
      )}
    </div>
  );
}

export default withTranslation()(ChartBlock);
